const buildCrewKey = (result) =>
  `${result?.driverName || ''}-${result?.coDriverName || ''}`;

export const groupResultsByCrew = (results = []) => {
  const order = [];
  const grouped = new Map();

  results.forEach((result) => {
    const key = buildCrewKey(result);

    if (!grouped.has(key)) {
      grouped.set(key, { baseResult: result, times: [] });
      order.push(key);
    }

    const entry = grouped.get(key);
    entry.times.push(result);
  });

  return order.map((key) => {
    const entry = grouped.get(key);

    // Use _timeSec (numeric) when available (engine format); fall back to string sort (SP format)
    const withSec = entry.times.filter(t => t._timeSec != null);
    let bestTime = null;
    if (withSec.length) {
      const bestSec = Math.min(...withSec.map(t => t._timeSec));
      bestTime = withSec.find(t => t._timeSec === bestSec)?.resultTime ?? null;
    } else {
      bestTime = entry.times.map(t => t.resultTime).filter(Boolean).sort()[0] || null;
    }

    return {
      baseResult: entry.baseResult,
      times: entry.times,
      bestTime,
    };
  });
};

const calcSpeed = (distanceKm, timeSec) => {
  if (distanceKm == null || timeSec == null || timeSec <= 0) return null;
  return Math.round((distanceKm / (timeSec / 3600)) * 10) / 10;
};

const fmtDiff = (diffSec) => {
  if (diffSec == null || diffSec <= 0) return null;
  const s  = Math.floor(diffSec);
  const ms = Math.round((diffSec - s) * 10);
  return `+${s}.${ms}`;
};

export const buildTestLeaderboardRows = (results = []) => {
  const groups = groupResultsByCrew(results);

  // Compute bestSec per crew first (needed for inter-crew diffs)
  const crewData = groups.map(({ baseResult, times, bestTime }) => {
    const distanceKm = times.find(t => t._distanceKm != null)?._distanceKm ?? null;
    const withSec    = times.filter(t => t._timeSec != null);
    const bestSec    = withSec.length ? Math.min(...withSec.map(t => t._timeSec)) : null;
    return { baseResult, times, bestTime, distanceKm, bestSec };
  });

  const leaderSec = crewData.find(c => c.bestSec != null)?.bestSec ?? null;

  return crewData.map(({ baseResult, times, bestTime, distanceKm, bestSec }, i) => {
    const prevSec    = i > 0 ? crewData[i - 1].bestSec : null;
    const allRuns = times.map((t, ri) => ({
      runNumber: ri + 1,
      time:      t.resultTime,
      isBest:    t._timeSec != null && t._timeSec === bestSec,
    }));

    return {
      ...baseResult,
      resultTime: bestTime,
      allRuns,
      allResults: times.map(t => t.resultTime),
    };
  });
};
